export const LIST_CONFIGURATION_REQUEST = 'LIST_CONFIGURATION_REQUEST'
export const LIST_CONFIGURATION_SUCCESS = 'LIST_CONFIGURATION_SUCCESS'
export const LIST_CONFIGURATION_FAIL = 'LIST_CONFIGURATION_FAIL'

export const LIST_CONFIGURATION_SUMMARY_REQUEST =
  'LIST_CONFIGURATION_SUMMARY_REQUEST'
export const LIST_CONFIGURATION_SUMMARY_SUCCESS =
  'LIST_CONFIGURATION_SUMMARY_SUCCESS'
export const LIST_CONFIGURATION_SUMMARY_FAIL = 'LIST_CONFIGURATION_SUMMARY_FAIL'